export default "__VITE_PUBLIC_ASSET__48df54fd__"